var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.40426,
    cy: 3.40426,
    r: 3.40426,
    transform: "matrix(-1 0 0 1 15.617 4.99988)",
    stroke: "#344054",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25531 16.8593C6.25531 16.1271 6.71561 15.4739 7.40517 15.2277V15.2277C10.5141 14.1174 13.9114 14.1174 17.0203 15.2277V15.2277C17.7099 15.4739 18.1702 16.1271 18.1702 16.8593V17.9789C18.1702 18.9895 17.2751 19.7658 16.2747 19.6229L15.9412 19.5752C13.4681 19.2219 10.9574 19.2219 8.48436 19.5752L8.15081 19.6229C7.15038 19.7658 6.25531 18.9895 6.25531 17.9789V16.8593Z",
    stroke: "#344054",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3191 11.9026C18.7964 11.9026 19.9939 10.7051 19.9939 9.22787C19.9939 7.75064 18.7964 6.5531 17.3191 6.5531",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2486 18.0049L20.5107 18.0424C21.2968 18.1547 22 17.5447 22 16.7507V15.871C22 15.2957 21.6384 14.7825 21.0966 14.589C20.5561 14.396 20.0046 14.2457 19.4468 14.1381",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.68088 11.9026C5.20364 11.9026 4.0061 10.7051 4.0061 9.22787C4.0061 7.75064 5.20364 6.5531 6.68088 6.5531",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75137 18.0049L3.48929 18.0424C2.70324 18.1547 1.99997 17.5447 1.99997 16.7507V15.871C1.99997 15.2957 2.36164 14.7825 2.90344 14.589C3.44389 14.396 3.99543 14.2457 4.55316 14.1381",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.ac93ba890a4e35c902dca77b7b3da26c.svg";
export { ForwardRef as ReactComponent };